// extracted by mini-css-extract-plugin
export default {"pageRoot":"AboutPage_pageRoot__nbxSW","root":"AboutPage_root__+wmlh","main":"AboutPage_main__AXaKY","heroContainer":"AboutPage_heroContainer__s9FPA","hero":"AboutPage_hero__xqZv0"};